import { useEffect } from 'react';

import { twMerge } from 'tailwind-merge';

import { useQueryPagination } from '../../../../../lib';
import { SelectModalWrapper } from '../select-modal';
import { ISelectPaginationOptions } from './types';

export const SelectQueryOptions = <TOption, TResponse>({
  optionsProps,
  queryParams,
  modalId,
}: ISelectPaginationOptions<TOption, TResponse>) => {
  const {
    reset,
    data,
    isFetchingNextPage,
    hasNext,
    isLoading,
    next,
    onSearch,
    search,
  } = useQueryPagination(queryParams);

  useEffect(() => {
    return reset;
  }, [reset]);

  return (
    <SelectModalWrapper
      {...optionsProps}
      modalProps={{
        ...(optionsProps?.modalProps ?? {}),
        classNames: {
          ...(optionsProps?.modalProps?.classNames ?? {}),
          wrapper: twMerge(
            'h-dvh pb-4',
            optionsProps?.modalProps?.classNames?.wrapper,
          ),
        },
      }}
      modalId={modalId}
      options={data}
      infinityProps={{
        hasNext,
        isLoadingMore: isFetchingNextPage,
        isLoading,
        next,
      }}
      searchValue={search}
      onSearchChange={onSearch}
    />
  );
};
